export const environment = {
  appName: 'STAGING - CAR+',
  apiUrl: 'https://test-carplus.cloven.it',
  keycloak: {
    url: 'https://auth.cloven.it',
    realm: 'test-carplus',
    clientId: 'carplus-web',
  },
};
